export { default } from './PostsGraph'
